import { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { LOGO } from "@/lib/catalog";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("tqb_admin_token", data.token);
      toast.success("Login realizado");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Falha no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen bg-white text-black">
      <header className="border-b border-black">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO} alt="The Quick Brownie" className="h-9 md:h-10" />
            <span className="font-display text-lg md:text-xl">The Quick Brownie</span>
          </Link>
          <span className="text-xs uppercase tracking-[0.2em]">Painel admin</span>
        </div>
      </header>

      <div className="mx-auto max-w-[460px] px-6 py-20 md:py-28">
        <h1 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-[-0.02em]">
          Bem-vindo<br />de volta.
        </h1>
        <p className="mt-6 text-base">Acesse o painel para visualizar e gerenciar os pedidos.</p>

        <form onSubmit={submit} className="mt-12 space-y-8" data-testid="admin-login-form">
          <div>
            <label className="text-xs uppercase tracking-[0.2em]" htmlFor="adm-email">E-mail</label>
            <input id="adm-email" data-testid="admin-email" type="email" required className="input-clean mt-2" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="thequickbrownie@gmail.com" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em]" htmlFor="adm-pass">Senha</label>
            <input id="adm-pass" data-testid="admin-password" type="password" required className="input-clean mt-2" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button type="submit" data-testid="admin-login-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </main>
  );
}
